import { useContext, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
// material
import { Stack, Box, Typography, TextField } from '@mui/material';
import { Icon } from '@iconify/react';
import checkmarkCircleFill from '@iconify/icons-eva/checkmark-circle-2-fill';
// material
import { LoadingButton } from '@mui/lab';
// contexts
import { useAuth } from '../../../contexts/Auth';
import { SettingsContext } from '../../../contexts/Settings';
// components
import UploadFileComponent from './upload';
// services
import { updateSettings } from '../../../services/Config';

export default function ProducerFormTheme() {
  const { authUser } = useAuth();

  const { authSettings, themeSettings, logo, settingsId } = useContext(SettingsContext);

  const [colorSuccess, setColorSuccess] = useState(false);

  const producerThemeValues = {
    theme: {
      color: themeSettings.palette.primary.main
    }
  };

  const ProducerThemeSchema = Yup.object().shape({
    theme: Yup.object({
      color: Yup.string()
    })
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: producerThemeValues,
    validationSchema: ProducerThemeSchema,
    onSubmit: async (values) => {
      setColorSuccess(false);

      try {
        const idToken = await authUser.getIdToken();
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Account-Key': authSettings.server.path
        };

        const payload = {
          'theme.color': values.theme.color
        };

        await updateSettings({ headers, payload, id: settingsId });
        setColorSuccess(true);
        window.location.reload();
      } catch (err) {
        console.error(err);
        alert('An error occurred! Please, try again.');
      }
    }
  });

  const { touched, errors, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <Box>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <Typography component="h2" variant="h6">
              Primary Color
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                fullWidth
                label="Color"
                placeholder="#000000"
                {...getFieldProps('theme.color')}
                error={Boolean(touched.theme?.color && errors.theme?.color)}
                helperText={touched.theme?.color && errors.theme?.color}
              />

              <LoadingButton
                size="large"
                type="submit"
                variant="contained"
                loading={isSubmitting}
                sx={{ ml: 1 }}
                endIcon={colorSuccess && <Icon icon={checkmarkCircleFill} />}
              >
                Save
              </LoadingButton>
            </Box>

            {errors.theme?.color && (
              <Typography variant="subtitle2" component="span" color="error">
                {errors.theme.color}
              </Typography>
            )}
          </Stack>
        </Form>
      </FormikProvider>

      <Stack spacing={2} sx={{ mt: 2 }}>
        <Typography component="h2" variant="h6">
          Upload Logo
          <Typography component="span" variant="body2" color="grey.500" sx={{ display: 'block' }}>
            This logo will appear on a white background
          </Typography>
          <Typography component="span" variant="body2" color="grey.500" sx={{ display: 'block' }}>
            Best size 500x160
          </Typography>
        </Typography>

        <UploadFileComponent
          settingsId={settingsId}
          fileUrl={logo.regular.url}
          fileField="theme.logo.regular.url"
        />
      </Stack>
    </Box>
  );
}
